import Add from '@mui/icons-material/Add';
import { Tab, Tabs } from '@mui/material';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { Component } from 'react';
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import DomainApi from '../../api/domains';
import EinApi from '../../api/eins';
import { withRouter } from '../../utils/withRouter';
import AddEins from './AddEins';
import Eins from './Eins';
import Exclusions from './Exclusions';
import Terminations from './Terminations';

class EINS extends Component
{
    tabs = {
        eins: 0,
        terminations: 1,
        exclusions: 2
    }

    state = {
        loading: true,
        mode: 'default',
        isEmpty: false,
        deleting: false,
        ein: null,
        eins: [],
        count: 0,
        page: 0,
        einId: null,
        currentTab: this.tabs.eins,
        domain: null
    }

    componentDidMount()
    {
        this.getDomain();

    }

    getEins = async (page) =>
    {
        try
        {
            const result = await EinApi.getEins(this.props.match.params.domainId, page)
            if (result)
            {
                this.setState({ loading: false, eins: result.eins, page: result.page, pages: result.pages, count: result.count })
            }
        } catch (error)
        {
            this.setState({ loading: false }, this.props.showError)
        }
    }

    getDomain = async () =>
    {
        try
        {
            const result = await DomainApi.get(this.props.match.params.domainId)
            if (result)
            {
                this.setState({ loading: false, domain: result })
            }
        } catch (error)
        {
            this.setState({ loading: false }, this.props.showError)
        }
    }
    render()
    {
        return (
            <div>
                <section className="animated fadeIn">
                    <header>
                        <div>
                            <h1>Eins Management {this.state.mode == 'add' && ` > Add New Eins`}</h1>
                            <h4 style={{ textAlign: "left" }}>{this.state.domain?.name}</h4>
                        </div>

                        <div className="actions" style={this.state.mode === "default" ? { top: -15 } : {}}>

                            {/* <AppBar position="static" color="default"> */}
                            {this.state.mode === "default" && <Tabs
                                value={this.state.currentTab}
                                onChange={(e, newValue) =>
                                    this.setState({ currentTab: newValue })
                                }
                                indicatorColor="primary"
                                textColor="primary"
                                centered
                            >
                                <Tab label="CENSUS FILE PROCESSING" />
                                <Tab label="TERMINATIONS" />
                                <Tab label="EXCLUSIONS" />

                            </Tabs>}
                            {/* </AppBar> */}
                            {this.state.mode !== "default" && <button onClick={() => this.setState({ mode: "default", ein: null })}>Close</button>}

                        </div>


                        {this.state.currentTab === 0 && this.state.mode === "default" &&
                            <Tooltip title="Add new Eins" placement="top" className="floating-button">
                                <Fab onClick={() => this.setState({ mode: 'add' })} variant="round" color="primary" aria-label="Add" >
                                    <Add />
                                </Fab>
                            </Tooltip>
                        }
                    </header>
                    <div className="line-break"></div>
                    {this.state.currentTab === this.tabs.eins && this.state.mode === "add" && <AddEins domainId={this.props.match.params.domainId} onCancel={() => this.setState({ ein: null })}
                        onCreate={() =>
                        {
                            this.getEins(this.props.match.params.domainId)
                            this.setState({ mode: "default" })
                        }} />
                    }

                    {this.state.currentTab === this.tabs.eins && this.state.mode === 'default' && <div><Eins mode={this.state.mode} /> </div>}
                    {this.state.currentTab === this.tabs.terminations && <Terminations />}
                    {this.state.currentTab === this.tabs.exclusions && <Exclusions />}
                </section>
            </div>
        )
    }
}
export default withRouter(connect(null, { showError, showMessage, confirmAction })(EINS));